<script setup>
const props = defineProps({
  type: {
    type: String,
    validator: (value) => ['Low', 'Medium', 'High'].includes(value),
    required: true
  }
})

const styles = {
  Low: ['', 'bg-opactiy-20', 'bg-opacity-20'],
  Medium: ['', '', 'bg-opacity-20'],
  High: ['', '', '']
}
</script>

<template>
  <div class="flex items-center gap-2">
    <div class="flex gap-[1.67px]">
      <span
        v-for="(style, index) in styles[type]"
        :key="index"
        :class="['w-[2.5px] h-[10px] rounded-[0.83px] bg-white', style]"
      />
    </div>
    <span>{{ type }}</span>
  </div>
</template>
